<template >
  <van-list v-model="loading" :finished="finished" @load="fetchData" :immediate-check="false">
    <van-icon slot="right-icon" name="search" class="van-cell__right-icon" />
    <template v-for="item in list">
      <order-list-cell :item="item" :key="item.id" @click.native="orderDetail(item.id)"></order-list-cell>
    </template>
  </van-list>

</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { List, Cell, Icon } from 'vant'
import OrderListCell from './OrderListCell'
import request from '@/utils/request'

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    OrderListCell
  },
  name: 'OrderList',
  props: {
    isOrderStatus: {
      type: Number,
      default: -1
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      nextPage: 1,
      loading: false,
      finished: false
    }
  },
  methods: {
    generateCustomizeString,
    onLoad() {
      this.fetchData()
    },
    orderDetail(orderId) {
      this.$router.push({
        name: 'OrderDetail',
        params: { orderId: orderId }
      })
      // this.$router.replace({ name: 'OrderDetail' })
    },
    fetchDataUseKeyword(keyword) {
      this.finished = false
      this.list = []
      let url1 = '/order-list?out_trade_no=' + keyword
      let url2 = '/order-list?express_number=' + keyword
      let url3 = '/order-list?phone=' + keyword
      let url4 = '/order-list?wx_nickname=' + keyword
      let url5 = '/order-list?consignee_name=' + keyword
      let url6 = '/order-list?consignee_phone=' + keyword
      let url7 = '/order-list?sender_name=' + keyword
      let url8 = '/order-list?sender_phone=' + keyword
      // 再加排序
      url1 = url1 + '&order=created_at_desc'
      url2 = url2 + '&order=created_at_desc'
      url3 = url3 + '&order=created_at_desc'
      url4 = url4 + '&order=created_at_desc'
      url5 = url5 + '&order=created_at_desc'
      url6 = url6 + '&order=created_at_desc'
      url7 = url7 + '&order=created_at_desc'
      url8 = url8 + '&order=created_at_desc'
      this.fetchDataUseUrl(url1)
      this.fetchDataUseUrl(url2)
      this.fetchDataUseUrl(url3)
      this.fetchDataUseUrl(url4)
      this.fetchDataUseUrl(url5)
      this.fetchDataUseUrl(url6)
      this.fetchDataUseUrl(url7)
      this.fetchDataUseUrl(url8)
    },
    fetchDataUseStatus() {
      let url = ''
      if (this.isOrderStatus === -1) {
        url = '/order-list?&order=created_at_desc'
      } else {
        url = '/order-list?status=' + this.isOrderStatus + '&order=created_at_desc'
      }

      const params = {
        page_size: 8,
        page: this.nextPage
      }
      this.fetchDataUseUrl(url, params)
    },
    fetchDataUseUrl(url, params) {
      if (this.finished === true) {
        return
      }
      this.loading = true
      request({
        url: url,
        method: 'get',
        params: params
      })
        .then(response => {
          var data = []
          // const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.orderId = response.data[i].out_trade_no
            obj.customerName = response.data[i].customer_name
            if (response.data[i].customer && response.data[i].customer.wechat_auths.length && response.data[i].customer.wechat_auths[0].user_info) {
              obj.headimgurl = response.data[i].customer.wechat_auths[0].user_info['headimgurl']
              obj.wechatName = response.data[i].customer.wechat_auths[0].user_info['nickname']
            } else {
              obj.wechatName = this.generateCustomizeString('none')
            }
            if (response.data[i].customer) {
              obj.remark = response.data[i].customer.remark
            }
            obj.amountofGoods = 'NZ $' + parseFloat(response.data[i].goods_fee / 100).toFixed(2)
            obj.shippingFee = 'NZ $' + parseFloat(response.data[i].express_fee / 100).toFixed(2)
            obj.totalFee = 'NZ $' + parseFloat(response.data[i].fee / 100).toFixed(2)
            obj.orderStatus = response.data[i].status_name
            obj.orderCreateAtStamp = new Date(response.data[i].created_at).getTime()
            obj.isPickUp = response.data[i].is_pick_up
            // obj.orderCreateAt = response.data[i].created_at.replace(/-/g, '/')
            // obj.orderCreateAt = dayjs(new Date(obj.orderCreateAt + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
            obj.orderCreateAt = response.data[i].created_at

            data.push(obj)
          }
          this.list = this.list.concat(data)

          if (this.isSearch) {
            // list 去重
            const result = {}
            const finalResult = []
            for (let i = 0; i < this.list.length; i++) {
              result[this.list[i].id] = this.list[i]
            }
            for (var item in result) {
              finalResult.push(result[item])
            }
            this.list = finalResult.sort(this.compare('orderCreateAtStamp'))
          }
          console.log(this.list)

          this.loading = false
          if (response.meta.current_page === response.meta.last_page) {
            this.finished = true
          } else {
            this.nextPage = response.meta.current_page + 1
          }
          // this.currentPage = meta.current_page
          // this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
    },
    compare(property) {
      return function(obj1, obj2) {
        var value1 = obj1[property]
        var value2 = obj2[property]
        return value2 - value1
      }
    },
    fetchData() {
      if (!this.isSearch) {
        this.fetchDataUseStatus()
      }
    }
  },
  created: function() {
    this.fetchData()
  }
}
</script>

<style>
</style>
